import { render, staticRenderFns } from "./PrintExpenses.vue?vue&type=template&id=bb4af3cc&scoped=true&"
import script from "./PrintExpenses.vue?vue&type=script&lang=js&"
export * from "./PrintExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4af3cc",
  null
  
)

export default component.exports